import React, { useEffect, useRef } from "react";

export default function OverviewChart({ labels, values }) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!window.Chart) return;

    const Chart = window.Chart;

    if (chartInstance.current) chartInstance.current.destroy();

    chartInstance.current = new Chart(chartRef.current, {
      type: "bar",
      data: {
        labels: labels,
        datasets: [
          {
            data: values,
            backgroundColor: (ctx) =>
              ctx.dataIndex === values?.length - 1 ? "#b57f00" : "#beb4b4",
            borderRadius: 10,
            barThickness: 12,
          },
        ],
      },
      options: {
        plugins: { legend: { display: false } },
        scales: {
          x: { grid: { display: false } },
          y: { display: false },
        },
      },
    });

    return () => chartInstance.current?.destroy();
  }, [labels, values]);

  return <canvas ref={chartRef}></canvas>;
}
